import React from 'react';
import { m } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
export function AboutAuthor() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-21" data-mp="2hf4lkrab19s1">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-22" data-mp="2m9h32vs80b15">
        <div className="mb-6 text-center" data-id="element-23" data-mp="2q9j8ng12tolp">
          <SectionTag icon="📚" data-id="element-24" data-mp="2q8hmafem1foo">Acerca de Educación Física FLASH</SectionTag>
        </div>

        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-slate-200 bg-bg-secondary p-8 text-center shadow-card sm:p-10" data-id="element-25" data-mp="1tktplmdpqpy5">
          <QuoteIcon size={28} className="mx-auto text-flash" data-id="element-26" data-mp="27k2tpnon9tlr" />
          <p className="mt-4 text-lg italic leading-relaxed text-ink sm:text-xl" data-id="element-27" data-mp="3dzluheeedybv">
            "He volcado en este sistema los esquemas reales que utilizamos para transformar clases
            improvisadas en sesiones con criterio profesional. Menos búsqueda en Pinterest. Más EF real en
            el patio."
          </p>
          <div className="mx-auto mt-6 max-w-xl border-t border-slate-200 pt-4" data-id="element-28" data-mp="25t9y3dn3t3uw">
            <p className="font-heading text-base font-bold text-ink" data-id="element-29" data-mp="20sm7uu6p8r1q">El Equipo de Educación Física FLASH</p>
            <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-30" data-mp="1vuu5154inkir">
              Profesores de Educación Física del sistema español con más de una década de experiencia en
              aulas de Primaria, ESO y Bachillerato. Formados en el patio ruidoso, en la reunión con
              familias difíciles y en la inspección que pregunta por LOMLOE. Todo lo que encontrarás en
              EF-FLASH viene de ahí. No de la teoría. De la clase real.
            </p>
          </div>
        </m.div>
      </div>
    </section>;
}